import Vue from 'vue'
import moment from 'moment'

const datetime = value => {
  if (!value) {
    return null
  }

  let dateFormat = 'DD/MM/YYYY [às] HH:mm'

  if (moment(value).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) {
    dateFormat = '[Hoje às] HH:mm'
  } else if (
    moment(value).format('DD/MM/YYYY') ===
    moment()
      .subtract(1, 'days')
      .format('DD/MM/YYYY')
  ) {
    dateFormat = '[Ontem às] HH:mm'
  } else if (
    value >
    moment()
      .subtract(7, 'days')
      .valueOf()
  ) {
    dateFormat = 'dddd [às] HH:mm'
  }

  return moment(value).format(dateFormat)
}

Vue.filter('datetime', datetime)
Vue.filter('time', value => moment(value).format('HH:mm:ss'))
Vue.filter('date', value => {
  let dateFormat = 'DD/MM/YYYY'

  if (moment(value).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) {
    dateFormat = '[Hoje]'
  } else if (
    moment(value).format('DD/MM/YYYY') ===
    moment()
      .subtract(1, 'days')
      .format('DD/MM/YYYY')
  ) {
    dateFormat = '[Ontem]'
  } else if (
    value >
    moment()
      .subtract(7, 'days')
      .valueOf()
  ) {
    dateFormat = 'dddd'
  }

  return moment(value).format(dateFormat)
})
Vue.filter('phone', str => {
  const cleaned = ('' + str).replace(/\D/g, '')
  let match = null

  if (cleaned.length === 10) {
    match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/)
  } else if (cleaned.length === 11) {
    match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/)
  } else if (cleaned.length === 12) {
    match = cleaned.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/)
  }

  if (match) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`
  }

  return null
})

Vue.filter('uppercase', value => (value || '').toString().toUpperCase())
Vue.filter('lowercase', value => (value || '').toString().toLowerCase())

Vue.filter('number', x => {
  if (typeof x === 'number') {
    x = x.toFixed(0)
  }

  return (x || '0').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})

Vue.filter('currency', number => {
  let formatted = parseFloat(number || 0).toFixed(2).toString().replace(/./g, function (c, i, a) {
    return i && c !== '.' && ((a.length - i) % 3 === 0) ? '.' + c : c
  })
  if (formatted.indexOf('-.') === 0) {
    formatted = '-' + formatted.substr(2)
  }
  if (formatted.indexOf('.') === 0) {
    formatted = formatted.substr(1)
  }
  return 'R$ ' + formatted.substr(0, formatted.lastIndexOf('.')) + ',' + formatted.substr(formatted.lastIndexOf('.') + 1)
})
